module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-mask",
    attrs: {
      "transition": "modal"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container modal-transition-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_vm._t("content")], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.cancel($event)
      }
    }
  }, [_vm._t("cancel", [_vm._v(_vm._s(_vm.$t('cancel')))])], 2), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.ok($event)
      }
    }
  }, [_vm._t("ok", [_vm._v(_vm._s(_vm.$t('ok')))])], 2)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2066c747"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/generic/ConfirmModal2.vue
// module id = 1023
// module chunks = 1